import { VisuallyHidden } from "@99tech/ui";
import { Box, Stack } from "@mui/material";
import React, { useCallback, useContext } from "react";
import { AppDownload, LoginButton, Logo, RegisterButton, Slotgames } from "src/assets";
import { FloatingBanner } from "src/main/components";
import { AppContext } from "src/main/constants";
import { createStyles } from "src/main/utils";

interface LandingPageProps extends React.PropsWithChildren {}

const LandingPage: React.FC<LandingPageProps> = (props) => {
  const { urls } = useContext(AppContext);
  const { loginUrl, registerUrl } = urls ?? {};

  const handleClick = useCallback(
    (type: "login" | "register") => () => {
      window.open(type === "login" ? loginUrl : registerUrl, "_blank");
    },
    [loginUrl, registerUrl],
  );

  return (
    <Box sx={styles.root}>
      <VisuallyHidden as="h1">Xo268</VisuallyHidden>
      <Stack
        alignItems="center"
        justifyContent="center"
        spacing={1.2}
      >
        <img
          alt="logo"
          src={Logo}
          width={250}
          height={84}
          style={{ marginTop: "16px", marginBottom: "16px" }}
        />

        <Stack
          direction="row"
          spacing={1}
        >
          <img
            alt="login"
            src={LoginButton}
            height={45}
            style={{ cursor: "pointer" }}
            onClick={handleClick("login")}
          />
          <img
            alt="register"
            src={RegisterButton}
            height={45}
            style={{ cursor: "pointer" }}
            onClick={handleClick("register")}
          />
        </Stack>
      </Stack>

      <img
        alt="hero backdrop"
        src={Slotgames}
        width={348}
        style={{ marginTop: "26px" }}
      />

      <img
        src={AppDownload}
        alt="app download"
        width={196}
        style={{ marginTop: "-8px" }}
      />

      <FloatingBanner />
    </Box>
  );
};

const styles = createStyles({
  root: {
    pt: "20px",
    pb: "110px",
    "@media (min-width: 800px)": {
      pb: "20px",
    },
    flexGrow: 1,
    display: "flex",
    flexDirection: "column",
    gap: "0px",
    position: "relative",
    alignItems: "center",
    justifyContent: "center",
    overflowX: "hidden",
  },
});

export default LandingPage;
